import Swiper from 'swiper/bundle';
export default function magazinSwiper() {

    const magazinSwiper = new Swiper(".avu-swiper-magazin", {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        rewind: true,
        pagination: {
            el: ".swiper-pagination-magazin",
            clickable: true,
            type: 'bullets',
        },
        navigation: {
            nextEl: ".swiper-button-next-magazin",
            prevEl: ".swiper-button-prev-magazin",
        },
    });
}